import React, { useEffect } from 'react';

import salonUpdateActionType from 'actions/salon/salonUpdate.at';
import HiddenDiv from 'components/core/HiddenDiv.component';
import PUSHER from 'config/pusher.singleton';
import ELID from 'constants/elid.const';
import { useCurrentSalonId } from 'providers/SalonBasicInfo.provider';
import logger from 'utils/logger.util';

const L = logger('SalonUpdateWatcher'); // eslint-disable-line no-unused-vars

const SalonUpdateWatcher = () => {
  const salonId = useCurrentSalonId();

  // SEE: https://getslick.atlassian.net/browse/GS-11063
  useEffect(() => {
    if (salonId) {
      L.info('Listening on salonId:', salonId, '...');

      return PUSHER.redux.listen({
        salonId,
        channelSuffix: '_channel',
        eventName: 'salon',
        at: salonUpdateActionType,
      });
    } else {
      L.info('Not listening on salonId:', salonId);
    }
  }, [salonId]);

  return <HiddenDiv tag="SalonUpdateWatcher--hidden" id={ELID.salupwatch} />;
};

// noinspection JSUnusedGlobalSymbols
export default SalonUpdateWatcher;
